module.exports = __webpack_public_path__ + "img/potencia_b_blue.9f85aa27.svg";